import type { ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

import { StandaloneFormShell } from './components/standalone-form-shell/standalone-form-shell.tsx'

/** The shell with a heading and three option rows, the shape of an intro or a question screen. */
export function StandaloneFormPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <StandaloneFormShell subscriptionId={undefined} progress={0} onBack={undefined} right={null} nextButton={undefined}>
      <LoadingRegion label={translate('loading_aria_label')}>
        <div className="flex flex-col gap-stack">
          <Skeleton variant="text" width="80%" height={32} />
          <Skeleton variant="block" height={56} />
          <Skeleton variant="block" height={56} />
          <Skeleton variant="block" height={56} />
        </div>
      </LoadingRegion>
    </StandaloneFormShell>
  )
}
